module.exports = __webpack_public_path__ + "img/0.9d958cc2.png";